export { default } from './ModalInstallmentDetail'
